import { Button, PageHeader } from 'components';
import { Form, Row, Col } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined } from '@ant-design/icons';
import DateSection from './formSections/date';
import DescriptionSection from './formSections/description';
import ShopSection from './formSections/shop';
import ImagesSection from './formSections/images';

import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import useBrands from '../useBrands';
import NotificationFormForEdit from '../../../../../components/modules/notificationFormForEdit';
import moment from 'moment';

const EditBrand = ({ isNew }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const {
    handleApprove,
    singleItem,
    form,
    updateInProcess,
    handleCreateOrUpdate,
    handleApproveOrReject,
    handleDeleteFile,
    filterData,
    siteCategories,
    approveErrors,
  } = useBrands(false);

  const onFinish = async (params) => {
    await handleCreateOrUpdate(params);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  const onApproveOrReject = async (publish, comment) => {
    const data = { comment };
    if (publish) {
      data.publish = +publish;
    } else {
      data.unpublish = +!publish;
    }

    await handleApproveOrReject(data);
  };

  const title = isNew ? t('PUBBLICA BRAND') : t('MODIFICA BRAND');
  const isApproveOnly = singleItem.can_approve && !singleItem.can_update;

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          initialValues={{
            company_id: '',
            description: '',
            title: '',
            phone: '',
            whatsapp: '',
            date_to: moment(),
            marketing_approved: false,
            retail_approved: false,
            date_from: moment(),
            site_category_ids: [],
            mapedin_id: '',
            working_hours: '',
            on_carousel: false,
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
        >
          <ShopSection
            shops={filterData.companies}
            inactiveShops={filterData.inactive_companies}
            isView={isApproveOnly}
          />
          <ImagesSection
            updateInProcess={updateInProcess}
            handleDeleteFile={handleDeleteFile}
            singleItem={singleItem}
            isEdit={!isNew}
            isView={isApproveOnly}
          />
          <DateSection isView={isApproveOnly} />
          <DescriptionSection isView={isApproveOnly} form={form} />

          {!isApproveOnly && (
            <Row gutter={16}>
              <Col>
                <Button
                  onClick={onClickSave}
                  width={'150px'}
                  big
                  loading={updateInProcess}
                  icon={<CheckOutlined />}
                >
                  {t('Invia')}
                </Button>
              </Col>
            </Row>
          )}
          {!isNew && (
            <NotificationFormForEdit
              loading={updateInProcess}
              handleOnFinish={handleApprove}
              showApprove={!!singleItem.can_approve}
              showReject={!!singleItem.can_reject}
              showToAdim={!!singleItem.can_to_admin}
              showRefuse={!!singleItem.can_refuse}
              approveKey={'publish'}
              rejectKey={'unpublish'}
              approveErrors={approveErrors.flat()}
            />
          )}
        </Form>
      </div>
    </div>
  );
};

export default EditBrand;
